import { apiClient } from './client';
import { isApiError } from './errors';
import type { RequestOptions } from '@/types/api';
import type {
  DashboardResponse,
  AuditLogsResponse,
  AuditLogEntry,
} from '@/types/dashboard';

/**
 * Dashboard API functions for the CDN Manager
 */
export const dashboardApi = {
  /**
   * Fetch dashboard statistics
   */
  async getStats(options?: RequestOptions): Promise<DashboardResponse> {
    const response = await apiClient.get<DashboardResponse>('/dashboard', {
      signal: options?.signal,
    });
    return response.data;
  },

  /**
   * Fetch recent audit logs for activity feed
   * Only returns results for admin users; others will get an empty response
   */
  async getRecentActivity(limit: number = 10, options?: RequestOptions): Promise<AuditLogEntry[]> {
    try {
      const response = await apiClient.get<AuditLogsResponse>('/audit/logs', {
        params: {
          limit,
          offset: 0,
        },
        signal: options?.signal,
      });
      return response.data.logs || [];
    } catch (error) {
      // If user doesn't have permission to view audit logs (non-admin),
      // return empty array silently
      if (isApiError(error) && error.status === 403) {
        return [];
      }
      throw error;
    }
  },
};
